import type { FindCircuitOnDiagram } from "./types";

/**
 * The same way is written "-0F5", "0F5" and "0f5" across the two documents, so
 * comparison drops everything that is not a letter or digit — the same rule
 * findCableGaps uses to join the plan to the schematic.
 */
const normalize = (value: string | null | undefined): string =>
  (value ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");

const pageIndexOf = (page: string): number => {
  const matched = page.match(/page_(\d+)/);
  return matched ? Number(matched[1]) : 0;
};

export const findCircuitOnDiagram: FindCircuitOnDiagram = ({
  diagram,
  designator,
}) => {
  const wanted = normalize(designator);
  if (!diagram || !wanted) return null;

  for (const itemType of diagram.itemTypes ?? []) {
    const occurrences = itemType.occurrences ?? [];
    for (let index = 0; index < occurrences.length; index += 1) {
      const occurrence = occurrences[index];
      const found = (occurrence.circuits ?? []).some(
        (circuit) => normalize(circuit) === wanted,
      );
      if (!found) continue;
      return {
        itemTypeId: itemType.diagram_item_type_id,
        occurrenceIndex: index,
        pageIndex: pageIndexOf(occurrence.page ?? ""),
        item: itemType.text || itemType.item || "",
        imageUrl: occurrence.imageUrl ?? "",
      };
    }
  }

  return null;
};
